<template>
    <div class="question-number">
        <div class="question-item-num">
            <div class="number" @click="editNumber">
                <span v-show="!dataList.hideTitle">{{ dataList.questionNumber }}</span>
            </div>
            <div class="number-input" v-show="showInput">
                <el-input ref="input" v-model="inputValue" @blur.stop="inputBlur" @input="inputEdit"></el-input>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref } from "vue";
import { numEditReg } from "@/utils/regRule";
import { ElMessage } from "element-plus";

const props = defineProps({
    dataList: {
        type: Object,
        default: () => ({}),
    },
});

const emits = defineEmits(["numberBlur"]);
// 用于存储数据的接口
let showInput = ref(false);
let inputValue = ref("");
let input = ref(null);
inputValue.value = props.dataList.questionNumber;

function editNumber() {
    showInput.value = true;
    input.value.focus();
}
// 失焦，存储数据
function inputBlur(e) {
    // 调接口保存到接口里面, saveData , 保存成功后执行下面
    // 修改原有数组库里题号
    let originalNumber = props.dataList.questionNumber;
    props.dataList.questionNumber = e.target.value ? e.target.value : props.dataList.questionNumber;

    showInput.value = false;
    emits("numberBlur", {
        originalNumber,
        currentNumber: props.dataList.questionNumber,
    });
}

// 实时输入，校验输入格式
function inputEdit(e) {
    // 判断输入格式的是否正确
    if (e && !numEditReg.test(e)) {
        ElMessage.error("只能输入【字母+数字 】或数字");
        inputValue.value = "";
    }
}
</script>
<style lang="scss" scoped>
.question-item-num {
    position: relative;
    .number {
        height: 37px;
        line-height: 37px;
        padding: 0 5px;
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0);
        font-size: 18px;
        &:hover {
            border-color: rgb(155, 173, 252);
        }
    }
    .number-input {
        position: absolute;
        top: 2px;
        left: 0;
        z-index: 999;
        width: 140px;
    }
}
</style>
